'use strict';

+function ($) {

  $.desktopMenu = function (option) {
    var open = option === 'show';
    if (option === 'toggle' && $('.desktop-menu').offset().left < 0) {
      open = true;
    }
    $('html').toggleClass('tablet-menu-open', open).toggleClass('desktop-menu-open', open);
  };

  $(document)
  // open & close the desktop-menu
  .on('click.bc.desktopMenu', '[data-toggle="desktop-menu"]', function (e) {
    e.preventDefault();
    $.desktopMenu('toggle');
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/desktop-menu.js
// module id = 5
// module chunks = 0